<template>
  <div class="cart-item-box">
    <order-item :item="item" :removable="preview === 0" @removeItem="removeFromList">
      <div v-if="item.purchasedate" slot="additional">
        <span v-if="preview" class="prior-purchase">Purchased</span>
        <a v-else href="/account/orders">Purchased on {{item.purchasedate}}</a>
      </div>
      <div slot="description" class="mt-15">
        <a v-if="item.in_cart"
                class="btn btn-primary btn-text"
                href="/cart">
          In bag, checkout
        </a>
        <button v-else-if="item.on_waitlist"
                class="btn btn-default btn-text"
                disabled>
          {{ item.stock }}, On wait list
        </button>
        <email-waitlist
                v-else-if="item.waitlist"
                :initial-email="item.email"
                :prodID="item.prodID"
                :colorcode="item.colorcode"
                :stylesize="item.stylesize"
                class="form-inline"/>
        <button v-else-if="!item.instock"
                class="btn btn-default btn-text"
                disabled>
          {{ item.stock }}
        </button>
        <button v-else
                class="btn btn-primary btn-text btn-add-to-bag"
                @click="addToCart">
          {{ buyButtonLabel() }}
        </button>
      </div>
    </order-item>
  </div>
</template>

<style scoped>
.prior-purchase {
  font-style: italic;
  font-weight: bold;
  color: #990033;
}
</style>

<script>
import { $cm } from '../../module/cart-manager'
import OrderItem from './../OrderItem'
import EmailWaitlist from './../EmailWaitlist'
import { MessageBox } from 'uiv'

export default {
    components: {
        'order-item': OrderItem,
        'email-waitlist': EmailWaitlist,
    },

    props: {
        preview: {
            type: Number,
            default: 1
        },
        item: {
            type: Object,
            default: null
        },
    },

    data () {
        return {
        }
    },

    methods: {
        removeFromList (item) {
              MessageBox.confirm({
                  title: 'Remove Wishlist Item',
                  content: 'Remove this item from your list?'
              }).then(() => {
                  this.$emit('removeItem', item.accountwishlistID)
              }).catch(() => {})
        },
        buyButtonLabel () {
            return this.item.purchasedate ? 'Buy again' : 'Add to Bag'
        },
        addToCart () {
            $cm.addItem(this.item.prodID, this.item.colorcode, this.item.stylesize, 1, this.item.accountwishlistID)
            this.item.in_cart = true
        },
    },
}
</script>
